<mds-grid
  [themeClass]="'ag-theme-material'"
  [minHeight]="'100%'"
  [overrides]="overrides"
  [sizeColumnsToFit]="true"
  (rowDoubleClicked)="onRowDoubleClicked($event)"
  (gridReady)="onGridReady($event)"
  (selectionChanged)="onSelectionChange()"
  (exportFinished)="setGridState()"
  (gridStateChanged)="onGridStateChanged()"
></mds-grid>

<ng-template #costModelBody>
  @if (costModelDialogData) {
    <app-cost-model-dialog-body
      [data]="costModelDialogData"
      (formValuesChange)="onCostModelFormValuesChange($event)"
    ></app-cost-model-dialog-body>
  }
</ng-template>

<ng-template #costModelActions>
  @if (costModelDialogData?.rowData.edit) {
    <mds-button (click)="onUpdateModel()" [type]="'primary'" [disabled]="!costModelFormValues.valid" role="button">
      Update model
    </mds-button>
  }
</ng-template>
